import {
  YardBlocksApi,
  YardBlocksApiYardBlocksCreateRequest,
  YardBlocksApiYardBlocksDeleteRequest,
} from '@storage/app/api'
import { createApiClient } from '@storage/app/http-client'

export class YardBlockService {
  public async deleteYardBlock(yardBlocksApiDeleteRequest: YardBlocksApiYardBlocksDeleteRequest) {
    return createApiClient(YardBlocksApi).yardBlocksDelete(yardBlocksApiDeleteRequest)
  }

  public async createYardBlock(yardBlocksApiCreateRequest: YardBlocksApiYardBlocksCreateRequest) {
    return createApiClient(YardBlocksApi).yardBlocksCreate(yardBlocksApiCreateRequest)
  }

  public async getYardBlockSummaries() {
    return createApiClient(YardBlocksApi).yardBlocksGetYardBlockSummaries()
  }

  public async getYardBlockSummary(id: string) {
    return createApiClient(YardBlocksApi).yardBlocksGetYardBlockSummary({ id })
  }

  public async loadYardBlocks() {
    const { data: yardBlocks } = await createApiClient(YardBlocksApi).yardBlocksGetAll()
    return yardBlocks
  }
}
